import { labService } from "../services";

export function getPackageTestnames(data, templateId, resCb) {
  return (dispatch) => {
    const encodeTemplateId = encodeURIComponent(templateId);
    labService.getPackageTestnames(data, encodeTemplateId).then(
      (user) => {
        console.log("Res", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export function getTestnames(templateId, resCb) {
  return (dispatch) => {
    const encodeTemplateId = encodeURIComponent(templateId);
    labService.getTestnames(encodeTemplateId).then(
      (user) => {
        console.log("Res", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export function getCategoryByTemplateId(templateId, resCb) {
  return (dispatch) => {
    labService.getCategoryByTemplateId(templateId).then(
      (user) => {
        console.log("Response for tab", user);
        // user now has { category: "...", footer: "..." }
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}
export function getFooterByTestName(testName, resCb) {
  return (dispatch) => {
    labService.getFooterByTestName(testName).then(
      (res) => resCb(res),
      (err) => resCb(err)
    );
  };
}
export function updateApprover(data, username, id, docId, resCb) {
  return (dispatch) => {
    labService.updateApprover(data, username, id, docId).then(
      (user) => {
        console.log("Respone for tab", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export function updateValidator(data, username, id, resCb) {
  return (dispatch) => {
    labService.updateValidator(data, username, id).then(
      (user) => {
        console.log("Respone for tab", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export function getPackageList(data, resCb) {
  return (dispatch) => {
    labService.getPackageList(data).then(
      (user) => {
        console.log("Respone for tab", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export function createLabPackage(data, resCb) {
  return (dispatch) => {
    labService.createLabPackage(data).then(
      (user) => {
        console.log("Respone for tab", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export function updatePackage(data, id, resCb) {
  return (dispatch) => {
    labService.updatePackage(data, id).then(
      (user) => {
        console.log("Respone for tab", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export async function getAllTestsInfo(testName, notes) {
  try {
    const testInfo = await labService.getAllTestsInfo(testName, notes);
    return testInfo;
  } catch (error) {
    console.error("Error in getAllSalesOrder:", error);
    throw error;
  }
}

export function updatePackageStatus(id, resCb) {
  return (dispatch) => {
    labService.updatePackageStatus(id).then(
      (user) => {
        console.log("Respone for tab", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export function createLabReportPDF(procedureId, resCb) {
  return (dispatch) => {
    labService.createLabReportPDF(procedureId).then(
      (user) => {
        console.log("Response for PDF creation", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

export function logInCheck(username, password, resCb) {
  return (dispatch) => {
    labService.logInCheck(username, password).then(
      (user) => {
        console.log("Response for PDF creation", user);
        resCb(user);
      },
      (error) => {
        resCb(error);
      }
    );
  };
}

function success(type, data) {
  return { type: type, payload: data };
}
function failure(type, value) {
  return { type: type, payload: value };
}
function request(type, value) {
  return { type: type, payload: value };
}

const labActions = {
  getPackageTestnames,
  getTestnames,
  getCategoryByTemplateId,
  getFooterByTestName,
  updateApprover,
  getPackageList,
  createLabPackage,
  updatePackage,
  getAllTestsInfo,
  updatePackageStatus,
  createLabReportPDF,
  logInCheck,
  updateValidator,
};

export default labActions;
